// extracted by mini-css-extract-plugin
export default {"wrapper":"LogoContainer_wrapper__qacxD"};